export default "__VITE_ASSET__CVh4lpvN__"